import {BooleanField, Datagrid, DateField, FunctionField, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {formatEuro, initField} from "../../shared/utils";
import {IdentifierField} from "../../components/IdentifierField";
import {SubjectField} from "../../components/SubjectField";
import {Typography} from "@material-ui/core";

export const JournalEntryDatagrid = ({
                                         options,
                                         ...rest
                                     }: DatagridPropsWithOptions) => {


    return (
        options &&
        <Datagrid {...rest}>
            <IdentifierField {...initField("id", options)} />
            <TextField {...initField("description", options)} style={{whiteSpace: "pre-wrap"}}/>
            <TextField {...initField("typology", options)}/>
            <TextField {...initField("document_number", options)} />
            <SubjectField {...initField("subject", options)} />
            <FunctionField
                label="Importo"
                render={(tableRecord: any | undefined) => {
                    if (tableRecord.journal_type === "I") {
                        return <Typography style={{color: "green", textAlign: "right", width: "100%"}}>+ {formatEuro(tableRecord.amount)}</Typography>
                    } else {
                        return <Typography color="primary" style={{textAlign: "right", width: "100%"}}>- {formatEuro(tableRecord.amount)}</Typography>
                    }
                }}
            />
            <DateField {...initField("date", options)} />
            <FunctionField
                render={(record: any) => record.bank_obj && `${record.bank_obj.id}: ${record.bank_obj.code}`}
                source="bank_obj"
                label="Banca"
            />
            <TextField {...initField("notes", options)} />
            <TextField {...initField("payment_method__display", options)} label="Metodo pagamento"/>
            <BooleanField {...initField("reconciled", options)} />
        </Datagrid>
    );
};
